export const accessReportHeaders = {
    header: [
        { name: 'instituicaoFinanceira', text: 'Instituição', position: 0 },
        { name: 'preferredUsername', text: 'Nome Usuário', position: 1 },
        { name: 'nomeUsuario', text: 'Nome Completo', position: 2 },
        { name: 'email', text: 'E-mail', position: 3 },
        { name: 'telefone', text: 'Telefone', position: 4 },
        { name: 'cpf', text: 'CPF', position: 5 },
        { name: 'acessoPerfil', text: 'Perfil', position: 6 },
        { name: 'dataAcesso', text: 'Data do Acesso', position: 7 }
    ]
}
